/**
 * 
 * 
 * 
 */
class StoreList extends HTMLElement {

    constructor() {
        super();
        this.innerHTML = `
            <style>
                .store-list {
                    list-style-type: none;
                    padding: 0;
                }
                
                .store-item {
                    margin: 10px 0;
                    padding: 10px;
                    border: 1px solid #ccc;
                    border-radius: 5px;
                }
            </style>
            <div class="store-list"></div>
        `;
        this.storeListElement = this.querySelector('.store-list');
    }

    connectedCallback() {
        this.fetchStoreList();
    }

    disconnectedCallback() {
        // Clear the interval when the element is removed from the DOM
        clearInterval(this.interval);
    }

    async fetchStoreList() {
            
        let fetchRes = await fetch(`https://bikila.tible.tech/shops-list`);
        let body     = await fetchRes.text();
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(body, 'text/html');
        this.storeListElement.innerHTML = ``;
        this.storeListElement.appendChild(htmlDoc.querySelector("#parsed-html"));
    }

     /**
     * 
     * Función de ayuda para simplificar la creación de Nodos
     * 
     * @param {String} type Tipo de nodo a crear
     * @param {String[Array]} classArray Clases que queremos añadir a nuestro elemento
     * @param {Object} options Opciones extra a añadir a nuestro elemento
     * @returns 
     */
    createNode(type, classArray = [], options = {}) {
        let node = document.createElement(type);
        // Asignamos todas las características de nuestro objeto al nodo creado 
        for (let [optionKey, optionValue] of Object.entries(options)) {
            node[optionKey] = optionValue;
        }
        
        // Asignamos las clases controlando errores
        classArray.map(singleClass => {
            try {
            node.classList.add(singleClass); 
            } catch (error) {
                console.warn(node, `Could not add the class ${singleClass} to the classList node`);
            }
        });      
        return node;
    }
}

customElements.define('store-list', StoreList);
